import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('PrincipalCheckConfigStats', PrincipalCheckConfigStatsData);

    function PrincipalCheckConfigStatsData() {
        function PrincipalCheckConfigStats(principalCheckConfigStatsData) {
            this.numberofCompanies = principalCheckConfigStatsData.numberofCompanies;
            this.numberofCompaniesWithPerimeter = principalCheckConfigStatsData.numberofCompaniesWithPerimeter;
            this.numberofValidPerimeters = principalCheckConfigStatsData.numberofValidPerimeters;
            this.numberofActiveContainers = principalCheckConfigStatsData.numberofActiveContainers;
            this.numberofCompaniesInvitatedAsSeller = principalCheckConfigStatsData.numberofCompaniesInvitatedAsSeller;
            this.numberofTotalSellers = principalCheckConfigStatsData.numberofTotalSellers;
            this.numberofMyInvoiceSellers = principalCheckConfigStatsData.numberofMyInvoiceSellers;
            this.numberofNotifiedSellers = principalCheckConfigStatsData.numberofNotifiedSellers;
            this.numberofValidatedSellers = principalCheckConfigStatsData.numberofValidatedSellers;
            this.numberofDisabledSellers = principalCheckConfigStatsData.numberofDisabledSellers;
            this.numberofDuplicatedSellers = principalCheckConfigStatsData.numberofDuplicatedSellers;
            this.numberofSellersWithoutEmail = principalCheckConfigStatsData.numberofSellersWithoutEmail;
        }

        return PrincipalCheckConfigStats;
    }
})();
